import { c as _c } from "react/compiler-runtime";
import type { DataOne } from '@cruz-com/lookup';
import _ from 'lodash';

// mpg
export const MPG = t0 => {
  const $ = _c(6);
  const {
    d
  } = t0;
  if (!d || _.isEmpty(d)) {
    return "-";
  }
  let t1;
  let t2;
  if ($[0] !== d) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let mpg;
      const t = d.length;
      if (t === 1) {
        mpg = d[0];
      } else {
        mpg = _.maxBy(d, _temp);
      }
      if (!mpg) {
        t2 = "-";
        break bb0;
      }
      const getDes = function getDes() {
        const parts = [];
        if (mpg?.fuel_grade) {
          parts.push(mpg.fuel_grade);
        }
        if (mpg?.fuel_type) {
          parts.push(mpg.fuel_type);
        }
        return parts.join(" ");
      };
      let t3;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <span className="ml-1 text-xs font-light">City</span>;
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      let t4;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <span className="h-4 border-r border-gray-400" />;
        $[4] = t4;
      } else {
        t4 = $[4];
      }
      let t5;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <span className="ml-1 text-xs font-light">Highway</span>;
        $[5] = t5;
      } else {
        t5 = $[5];
      }
      t1 = <div className="flex items-center gap-x-2"><span>{mpg.city}{t3}</span>{t4}<span>{mpg.highway}{t5}</span>{t > 1 && <span className="ml-2 text-xs font-light">({getDes()}) ...</span>}</div>;
    }
    $[0] = d;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return t1;
};
function _temp(x) {
  return (x?.city || 0) + (x?.highway || 0);
}